import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mbody"
};
const _hoisted_2 = {
  class: "form-group"
};
const _hoisted_3 = {
  class: "form-group"
};
const _hoisted_4 = {
  class: "code-input-wrapper"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  class: "mfoot"
};
import { ref, computed, watch } from "vue";
import request from "@/utils/request";
import toast from "@/utils/toast";
import { setUserData } from "@/utils/auth";
export default {
  __name: 'LoginDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "close", "submit", "login-success"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 使用计算属性处理 v-model
    const visible = computed({
      get: () => props.modelValue,
      set: value => emit("update:modelValue", value)
    });
    const phone = ref("");
    const code = ref("");
    const countdown = ref(0);
    let countdownTimer = null;

    // 验证手机号格式
    const isValidPhone = computed(() => {
      return /^1[3-9]\d{9}$/.test(phone.value);
    });

    // 是否可以提交
    const canSubmit = computed(() => {
      return isValidPhone.value && code.value.length >= 6;
    });

    // 监听显示状态，重置表单
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        // 打开弹窗时重置表单
        phone.value = "";
        code.value = "";
        countdown.value = 0;
        if (countdownTimer) {
          clearInterval(countdownTimer);
          countdownTimer = null;
        }
      }
    });

    // 发送验证码
    const sendCode = async () => {
      if (!isValidPhone.value) {
        toast("请输入正确的手机号");
        return;
      }
      try {
        const res = await request.post("/api/v1/user/phone/code", {
          phone: phone.value,
          bizType: "login"
        });
        if (res.code === 200 || res.success) {
          toast("验证码已发送");
          startCountdown();
        } else {
          toast(res.message || "发送失败，请稍后重试");
        }
      } catch (error) {
        console.error("发送验证码失败:", error);
        toast("发送失败，请稍后重试");
      }
    };

    // 开始倒计时
    const startCountdown = () => {
      countdown.value = 60;
      countdownTimer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
          clearInterval(countdownTimer);
          countdownTimer = null;
        }
      }, 1000);
    };

    // const handleMaskClick = () => {
    //   emit("update:modelValue", false);
    // };

    const close = () => {
      emit("update:modelValue", false);
      emit("close");
    };
    const submit = async () => {
      if (!canSubmit.value) {
        toast("请填写完整的登录信息");
        return;
      }
      try {
        // api/v1/user/info 获取用户信息
        const res = await request.post("/api/v1/user/login", {
          source: "personal",
          loginType: "phone",
          phone: phone.value,
          verifyCode: code.value
        });
        if (res.code === 200) {
          // 保存 token
          if (res.data?.token) {
            // setToken(res.data.token);
            setUserData(res.data);
          }
          toast("登录成功");
          emit("login-success", res.data);
          emit("submit", res.data);
          close();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toast(res.msg || "登录失败");
        }
      } catch (error) {
        console.error("登录失败:", error);
        toast("登录失败，请稍后重试");
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_CompetitionDialog = _resolveComponent("CompetitionDialog");
      return _openBlock(), _createBlock(_component_CompetitionDialog, {
        style: {
          zIndex: 51
        },
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => visible.value = $event),
        title: "手机号登录",
        width: 480,
        onClose: close
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          size: "large",
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          onClick: submit,
          disabled: !canSubmit.value
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("登录", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("label", {
          class: "form-label"
        }, "手机号", -1)), _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input",
          placeholder: "请输入手机号",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => phone.value = $event),
          maxlength: "11"
        }, null, 512), [[_vModelText, phone.value]])]), _createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("label", {
          class: "form-label"
        }, "验证码", -1)), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-input code-input",
          placeholder: "请输入验证码",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => code.value = $event),
          maxlength: "12"
        }, null, 512), [[_vModelText, code.value]]), _createElementVNode("button", {
          class: "send-code-btn",
          disabled: countdown.value > 0 || !phone.value,
          onClick: sendCode
        }, _toDisplayString(countdown.value > 0 ? `${countdown.value}s` : "获取验证码"), 9, _hoisted_5)])])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};